export const data = [
  {
    path: '/data/formList',
    component: () => import(/* webpackChunkName: "formList" */ '@/views/data/formList.vue')
  },
  {
    path: '/data/report/investPerformance',
    component: () => import(/* webpackChunkName: "investPerformance" */ '@/views/data/report/investPerformance.vue')
  },
  {
    path: '/data/report/USDIR',
    component: () => import(/* webpackChunkName: "USDIR" */ '@/views/data/report/USDIRReport.vue')
  },
  {
    path: '/data/report/legalDeliveryScale',
    component: () => import(/* webpackChunkName: "legalStartScale" */ '@/views/data/report/legalDeliveryScale.vue')
  },
  {
    path: '/data/report/legalStartScale',
    component: () => import(/* webpackChunkName: "legalStartScale" */ '@/views/data/report/legalStartScale.vue')
  },
  {
    path: '/data/report/middlePage',
    component: () => import(/* webpackChunkName: "middlePage" */ '@/views/data/report/middlePageReport.vue')
  },
  {
    path: '/data/report/voteOverviewReport',
    component: () => import(/* webpackChunkName: "voteOverviewReport" */ '@/views/data/report/voteOverviewReport.vue')
  },
  {
    path: '/data/report/voteRawReport',
    component: () => import(/* webpackChunkName: "voteRawReport" */ '@/views/data/report/voteRawReport.vue')
  },
  {
    path: '/data/report/qualityReport',
    component: () => import(/* webpackChunkName: "qualityReport" */ '@/views/data/report/qualityReport.vue')
  },
  {
    path: '/data/report/irRmb',
    component: () => import(/* webpackChunkName: "irRmbBitableReport" */ '@/views/data/report/RMBIRBitableReport.vue')
  },
  {
    path: '/data/report/irUsd',
    component: () => import(/* webpackChunkName: "irUsdBitableReport" */ '@/views/data/report/USDIRBitableReport.vue')
  },
  {
    path: '/data/report/controllist',
    component: () => import(/* webpackChunkName: "controllistBitableReport" */ '@/views/data/report/controllistBitableReport.vue')
  }
];
